import { triggerByText } from "@uri/silly-nlp";
import {
  concat,
  letIn,
  map,
  mapCat,
  pairRight,
  pipe,
  sort,
  unique,
} from "gamla";
import type { Language } from "./texts.ts";
import { objectKeys, valFilterSync } from "./utils.ts";

export const geoCategories: Category[] = ["out of town"];

export type Performer = { key: string; categories: Category[] };

export type Venue = {
  name: string;
  location: string;
  url: string;
  keywords: string[];
  antiKeywords?: string[];
  categories: Category[];
};

export const knownVenues: Venue[] = [
  {
    name: "AudioPhil",
    url: "https://linktr.ee/audiophiltlv/",
    location: "Shvil ha-Tnufa 7, Tel Aviv-Yafo",
    keywords: ["אודיופיל", "audiophil", "audiophile"],
    categories: [],
  },
  {
    name: "LAYLA",
    url: "https://www.layla-bar.co.il/",
    location: "Yavne St 31, Tel Aviv-Yafo",
    keywords: ["layla"],
    categories: ["gays"],
  },
  {
    name: "Shalvata",
    url: "https://shalvata.co.il/",
    location: "HaTa'arucha St 3, Tel Aviv-Yafo",
    keywords: ["shalvata", "שלוותה"],
    categories: [],
  },
  {
    name: "Lima Lima",
    url: "https://www.instagram.com/lima_lima_bar/",
    location: "Lilienblum St 42, Tel Aviv-Yafo",
    keywords: ["lima lima", "לימה לימה"],
    categories: [],
  },
  {
    name: "מועדון 2vs2",
    url: "https://2vs2.co.il/",
    location: "חולון",
    keywords: ["מועדון 2vs2", "2vs2 club"],
    categories: ["swingers"],
  },
  {
    name: "אומן 17",
    url: "https://www.instagram.com/haoman17tlv/",
    location: "Abarbanel St 88, Tel Aviv-Yafo",
    keywords: ["אומן 17", "haoman 17"],
    categories: [],
  },
  {
    name: "Phi Garden",
    url: "https://instagram.com/phi_garden",
    location: "Ahad Ha'Am St 54, Tel Aviv-Yafo",
    keywords: ["phi", "phi garden", "פאי", "phigarden", "phi_garden"],
    antiKeywords: ["tomer versace"],
    categories: ["techno"],
  },
  {
    name: "Collabo",
    location: "Derekh Ben-Zvi 47, Tel Aviv-Yafo, 6810331",
    url: "https://instagram.com/collabo_tlv",
    keywords: ["קולאבו", "collabo", "colabo"],
    categories: ["techno"],
  },
  {
    name: "Traklin",
    location: "Karkur, Israel",
    url: "https://www.instagram.com/traklin_pardes_hanna/",
    keywords: ["הטרקלין", "טרקלין", "בטרקלין"],
    categories: ["out of town"],
  },
  {
    name: "Gagarin",
    location: "Kibbutz Galuyot Rd 13, Tel Aviv-Yafo",
    url: "https://instagram.com/gagarin_tlv",
    keywords: ["גגרין", "gagarin"],
    categories: ["techno"],
  },
  {
    name: "Bor",
    location: "שדרות רוטשילד 31, תל אביב-יפו, ישראל",
    url: "https://instagram.com/bor_tlv",
    keywords: ["bor", "בור"],
    categories: ["techno"],
  },
  {
    name: "Ibiza VC",
    location: "Yefet 29, Tel Aviv-Yafo",
    url: "https://www.facebook.com/AnanasAndLasers?mibextid=ZbWKwL",
    keywords: ["ibiza", "אננס ולייזרים", "איביזההה"],
    categories: ["techno"],
  },
  {
    name: "Gag 21,",
    location: "סירקין 21",
    url: "https://www.instagram.com/gag21_talpiot?igsh=MW9ycGNicnJ6YTUwcw==של",
    keywords: ["gag21", "גג 21", "gag 21"],
    categories: ["techno"],
  },
  {
    name: "2Sick,",
    location: "שרה 1, חיפה",
    url: "https://www.instagram.com/haifa2sick?igsh=MXRyb3g5aWhkYTZ4OA==",
    keywords: ["2sick", "2 sick", "2sick studio"],
    categories: ["live music"],
  },
  {
    name: "רודיאו,",
    location: "בלפור 23, חיפה",
    url: "https://rodeohaifa.com/",
    keywords: ["רודיאו", "rodeo"],
    categories: ["live music"],
  },
  {
    name: "HQRN,",
    location: "סירקין 5, חיפה",
    url: "https://www.facebook.com/HQRNart",
    keywords: ["hqrn", "sirkin 5"],
    categories: [],
  },
  {
    name: "Chester Kittchen,",
    location: "הנמל 63, חיפה",
    url: "https://www.instagram.com/chester.kittchen?igsh=MWhneTR4ZzA5aW11cQ==",
    keywords: ["chester kittchen", "צסטר קיצן", "צ'סטר"],
    categories: ["live music"],
  },
  {
    name: "וונדרבר,",
    location: "דרך חטיבת גולני 18, חיפה",
    url: "https://www.wunderbar.co.il/ ",
    keywords: ["wunderbar", "wunder bar", "וונדרבר"],
    categories: [],
  },
  {
    name: "לובר,",
    location: 'פלי"ם 2, חיפה',
    url: "https://www.instagram.com/louvre.haifa?igsh=MTF3d3ZhbGtsNHhqZg==",
    keywords: ["louvre", "לובר"],
    categories: [],
  },
  {
    name: "סקולה,",
    location: 'פלי"ם 14, חיפה',
    url: "https://www.instagram.com/skolabar?igsh=aGwzbHp3Yms2MHox",
    keywords: ["skola", "סקולה"],
    categories: ["live music"],
  },
  {
    name: "שוקרי סשנז,",
    location: "חיפה",
    url: "https://www.facebook.com/shukri04",
    keywords: ["shukri", "שוקרי"],
    categories: ["live music"],
  },
  {
    name: "מרי בר,",
    location: "נתנזון 16, חיפה",
    url: "https://www.facebook.com/marybarhaifa?mibextid=ZbWKwL",
    keywords: ["mary bar", "מרי בר"],
    categories: ["live music"],
  },
  {
    name: "Birdy cafe,",
    location: "שדרות מוריה 9, חיפה",
    url: "https://www.instagram.com/birdy.cafe.bar?igsh=MXJ4cnVpNmJuNmZobw==",
    keywords: ["birdy cafe", "בירדי", "בירדי קפה"],
    categories: ["live music"],
  },
  {
    name: "אלי'ס פאב",
    location: "דרך יפו 35, חיפה",
    url: "https://elispub.co.il/",
    keywords: ["elis", "אליס פאב"],
    categories: ["live music"],
  },
  {
    name: "זאפה חיפה,",
    location: "דרך משה פלימן 2-8, חיפה",
    url: "https://www.facebook.com/zappahaifa?mibextid=ZbWKwL",
    keywords: ["zappa haifa", "זאפה חיפה"],
    categories: ["live music"],
  },
  {
    name: "מרכז הקונגרסים,",
    location: " קדושי יאסי 2, חיפה",
    url: "https://www.facebook.com/icchaifa",
    keywords: ["congres center", "מרכז הקונגרסים"],
    categories: ["live music"],
  },
  {
    name: "הנביאים בית ספר לאומנות,",
    location: "יחיאל 3, חיפה",
    url: "https://www.facebook.com/HaNeviim?mibextid=ZbWKwL",
    keywords: ["הנביאים בית ספר לאומנות"],
    categories: ["live music"],
  },
  {
    name: "תיאטרון הסטודיו,",
    location: "שדרות הנשיא 142, חיפה",
    url: "https://hastudio-tr.co.il/",
    keywords: ["תיאטרון הסטודיו", "בית הכט"],
    categories: ["theater"],
  },
  {
    name: "sabababar,",
    location: "דרך העצמאות 84, חיפה",
    url: "https://www.facebook.com/sabababarhaifa?mibextid=ZbWKwL",
    keywords: ["sabababar", "סבבה בר", "סבבהבר"],
    categories: ["standup"],
  },
  {
    name: "sleek,",
    location: "שדרות הנשיא 134, חיפה",
    url: "https://www.facebook.com/sleek.haifa.9",
    keywords: ["sleek", "סליק בר", "סליק"],
    categories: ["live music"],
  },
  {
    name: "OM,",
    location: "חטיבת גולני 12, חיפה",
    url: "https://instagram.com/p/DAwCaJctYI4?igsh=MXN3MXVtNDY3Y3Q2cg==",
    keywords: ["om", "אואמ"],
    categories: ["live music"],
  },
  {
    name: "מקום לשירה,",
    location: "סירקין 5, חיפה",
    url: "https://www.poetryplace.org/",
    keywords: ["poatry place", "מקום לשירה"],
    categories: ["live music"],
  },
  {
    name: "Z-City Club,",
    location: "נתנזון 10, חיפה",
    url: "https://www.facebook.com/130814zcb",
    keywords: ["Z-City Club", "זי סיטי", "z city"],
    categories: ["live music"],
  },
  {
    name: "Bavel",
    location: "Mikve Israel St 8, Tel Aviv-Yafo",
    url: "https://instagram.com/baveltlv",
    keywords: ["בבל", "bavel"],
    categories: ["techno"],
  },
  {
    name: "סילו תרבות",
    location: "כנרת, הוד השרון",
    url: "https://www.siloculture.com/",
    keywords: ["סילו תרבות", "silo culture"],
    categories: [],
  },
];

export const commonVenueNames = knownVenues.map((x) => x.name);

const keyToVenue = Object.fromEntries(
  knownVenues.map((v) => [v.name, v] as [string, Venue]),
);

export const findVenue = pipe(
  triggerByText<string>(keyToVenue),
  map((x: string) => keyToVenue[x]),
);

type CategorySpec = {
  display: Record<Language, string>;
  emoji: string;
  keywords: string[];
  antiKeywords?: string[];
  aiHint?: string;
};

const productions: Record<string, CategorySpec> = {
  "mycophobia-community": {
    display: { en: "Mycophobia community", he: "קהילת מיקופוביה" },
    emoji: "🍄",
    keywords: [
      "myco",
      "mycotown",
      "מיקופוביה",
      "mycophobia",
      "mycophobiia",
      "@mycophobiia",
      "לאבו",
      "לאבולושיין",
      "loveolution",
      "מיקו",
    ],
  },
};

const catsUntyped: Record<string, CategorySpec> = {
  ...productions,
  sexuality: {
    display: { en: "Sexuality", he: "מיניות" },
    aiHint:
      "e.g. sex positive parties or festivals, intimacy festivals and so on.",
    emoji: "❤️‍🔥",
    antiKeywords: ["מוניקה סקס"],
    keywords: [
      "sex",
      "sexuality",
      "אינטימיות",
      "מיניות",
      "סקס",
      "עירום",
    ],
  },
  party: {
    display: { en: "Parties", he: "מסיבות" },
    emoji: "🎉",
    keywords: ["party", "parties", "מסיבה", "מסיבות", "מסיבת", "לרקוד"],
  },
  sports: {
    display: { en: "Sports", he: "ספורט" },
    emoji: "🏃",
    antiKeywords: ["בגדי ספורט"],
    keywords: ["sport", "ספורט"],
  },
  swimming: {
    display: { en: "swimming", he: "שחייה" },
    emoji: "🏊",
    keywords: [
      "swim",
      "swimming",
      "swimmer",
      "swimmers",
      "שחייה",
      "לשחות",
      "שחיה",
      "שחיין",
      "שחיינית",
      "בריכת שחייה",
      "בריכת שחיה",
    ],
  },
  volleyball: {
    display: { en: "volleyball", he: "כדורעף" },
    emoji: "🏐",
    keywords: [
      "volleyball",
      "beach volleyball",
      "כדורעף",
      "כדורסף",
      "כדורעף חופים",
    ],
  },
  dubstep: {
    display: { en: "Dubstep", he: "דאבסטפ" },
    emoji: "🔊🫠",
    keywords: ["dubstep", "דאבסטפ"],
  },
  anime: {
    display: { en: "anime / cosplay", he: "אנימה וקוספליי" },
    emoji: "🦊",
    keywords: [
      "anime",
      "אנימה",
      "manga",
      "מאנגה",
      "cosplay",
      "קוספליי",
      "otaku",
      "אוטאקו",
      "anime night",
      "anime party",
    ],
  },
  "open-mic": {
    display: { en: "Open mic", he: "במה פתוחה" },
    emoji: "🎤",
    keywords: ["open mic", "במה פתוחה", "במות פתוחות"],
  },
  "karaoke": {
    display: { en: "Karaoke", he: "קריוקי" },
    emoji: "🎤",
    keywords: [
      "karaoke",
      "karaoke night",
      "karaoke party",
      "קריוקי",
    ],
  },
  "80s": {
    display: { en: "80s", he: "אייטיז" },
    emoji: "🛼",
    keywords: ["80s", "שנות השמונים", "אייטיז", "שנות 80", "שנות ה80"],
  },
  "burn": {
    emoji: "🔥",
    display: { en: "burn", he: "מידברן" },
    keywords: [
      "burning man",
      "cube",
      "k קמפ",
      "midburn",
      "le cube",
      "playa",
      "shliff",
      "ursul",
      "אקווה",
      "אקסטאטיקה",
      "ארט",
      "באבאזמן",
      "באדולינה",
      "באובב",
      "בעקבות מנהרות הארנב",
      "ברן",
      "ברנורות",
      "ברנפלקס",
      "ברנרות",
      "גלגל המזל",
      "גריטיקל",
      "דיקו",
      "דיקומפרשיין",
      "היהלומים",
      "הלמון טרי",
      "המדבוריה",
      "וונוס בפרוות",
      "זקני השבט",
      "חאג מולד",
      "חבריםשלמידברן",
      "טורטיה פייט קלאב",
      "טכנודרום",
      "לאמסיבתגיוס",
      "לה לאמפה",
      "לייבזון",
      "מדיקאמפ",
      "מורגנה בשמש",
      "מחניודה",
      "מידברן",
      "מלביט",
      "מסיבת גיוס",
      "מסיבתגיוס",
      "מרבד הקסמים",
      "ניסויים בבני אדם",
      "סאנרייז",
      "סלוט משין",
      "סרנגה קמפ",
      "פייר",
      "פיירוס",
      "פיקסל",
      "פלאיה",
      "פלאן בי תמנונים",
      "פלמינגודס",
      "פרילאב",
      "פתיתים",
      "קאמפ",
      "קולדפשן",
      "קוסומו",
      "קיוב",
      "קנדילנד",
      "קריוקמפ",
      "קריסטל גריי",
      "ריבת חלל",
      "רינגו סטאר",
      "שבורית זכוכה",
      "שדוזה",
      "שטיפל'ה",
      "שטיפלה",
      "שטנצ",
      "שיטים של חד קרן",
      "שלאפי",
      "שליף",
      "שנטיפי",
      "שניצולים",
    ],
    aiHint:
      "Burning man community events. Usually these would be parties or festivals, and they can be recognized by using burning man terms, like playa (פלאיה), recruitment parties (מסיבת גיוס) and so on. If unsure do not add this category.",
  },
  "crafts": {
    display: { en: "crafts", he: "סדנאות" },
    emoji: "🪡",
    keywords: [
      "crafts",
      "סדנת רקמה",
      "workshop",
      "סדנאות",
      "סדנת כתיבה",
      "סדנה",
    ],
  },
  "classic music": {
    display: { en: "classical music", he: "מוסיקה קלאסית" },
    emoji: "🎹",
    keywords: [
      "classical music",
      "ארבע העונות",
      "בטהובן",
      "ברנשטיין",
      "גריג",
      "האנסמבל",
      "ויואלדי",
      "לברי",
      "מוזיקה קלאסית",
      "מוסיקה קלאסית",
      "קונצרט",
      "רקוויאם",
    ],
  },
  "dance": {
    display: { en: "dance", he: "מחול וריקוד" },
    emoji: "🩰",
    antiKeywords: ["אורח מיוחד מחול"],
    keywords: [
      "baile",
      "cabaret",
      "cabret",
      "ecstatic",
      "funk",
      "guarana",
      "swing",
      "גוארנה",
      "הגוארנה",
      "מחול",
      "פיאסטה קלאב",
      "קברט",
      "ריקודי סווינג",
    ],
  },
  salsa: {
    display: { en: "Salsa", he: "סלסה" },
    emoji: "💃",
    keywords: ["salsa", "סלסה", "ערב סלסה"],
  },
  bachata: {
    display: { en: "Bachata", he: "בצ'אטה" },
    emoji: "💃",
    keywords: ["bachata", "באצטה", "בצטה", "בצ'אטה", "באצ'טה"],
  },
  tango: {
    display: { en: "Tango", he: "טנגו" },
    emoji: "🥀",
    keywords: ["tango", "טנגו", "milonga", "מילונגה"],
  },
  kizomba: {
    display: { en: "Kizomba", he: "קיזומבה" },
    emoji: "💃",
    keywords: ["kizomba", "קיזומבה"],
  },
  zouk: {
    display: { en: "Zouk", he: "זוק" },
    emoji: "💃",
    keywords: ["zouk", "זוק", "brazilian zouk"],
  },
  "dancehall": {
    display: { en: "dancehall", he: "דאנסהול" },
    emoji: "🎶",
    keywords: ["dancehall", "דאנסהול"],
  },
  "reggae": {
    display: { en: "reggae", he: "רגאיי" },
    emoji: "🇯🇲",
    keywords: ["reggae", "רגאיי", "רגיי", "ska", "סקא", "dub"],
  },
  "ecstatic": {
    display: { en: "ecstatic", he: "אקסטטיק" },
    emoji: "🎶",
    antiKeywords: ["ecstatic vibe"],
    keywords: [
      "adi bareket",
      "alchemy",
      "aman",
      "amber ra shefa",
      "ben david",
      "bickeloz",
      "circle of ecstasy",
      "dj baraku",
      "dj dito",
      "ecstasea",
      "ecstatic",
      "ecstaticdance",
      "gal rosenberg",
      "guy shani",
      "kadmon",
      "laniakea",
      "light child",
      "lior grayevski",
      "makatu",
      "miss albi",
      "omer gonen haela",
      "ron rambell",
      "ron rambell",
      "ron rambell",
      "selva",
      "shlomi eliash",
      "spiritito",
      "sultana",
      "sutra",
      "the playground",
      "yonder",
      "zazoo",
      "אקסטאטיק",
      "אקסטאסי",
      "אקסטטיק",
      "אקסטסי",
      "הארטביט",
      "הפלייגראונד",
      "ללאניאקאה",
      "מסיבה אקסטטית",
      "מעיין רחמים",
    ],
  },
  "exhibition": {
    display: { en: "exhibitions", he: "תערוכות" },
    emoji: "🎨",
    keywords: [
      "exhibition",
      "gallery",
      "גלריה",
      "מודל רישום",
      "סטודיו",
      "רישום מודל",
      "רישום עירום",
      "תערוכה",
      "תערוכות",
      "תערוכת",
    ],
  },
  "film": {
    display: { en: "Film", he: "קולנוע" },
    aiHint: "e.g. screenings, festivals, documentaries, talks about movies.",
    emoji: "🎥",
    keywords: [
      "cinema",
      "documentary",
      "film",
      "movie",
      "screening",
      "דוקומנטרי",
      "הקרנה",
      "סינמה סירקין",
      "סינמהדר",
      "סרט",
      "קולנוע",
    ],
  },
  "volunteer": {
    display: { en: "volunteer", he: "התנדבות" },
    emoji: "🫶",
    keywords: [
      "volunteer",
      "התנדבות",
      "תרומה לקהילה",
      "לתרום",
      "מתנדבים",
      "להתנדב",
    ],
  },
  "singing circle": {
    display: { en: "singing circle", he: "מעגל שירה" },
    emoji: "🫶",
    keywords: [
      "singing citcle",
      "מעגל שירה",
      "שירה בציבור",
    ],
  },
  "race": {
    display: { en: "race", he: "מירוץ" },
    emoji: "🦸",
    keywords: ["מירוץ", "race", "חצי מרתון", "ריצת ניווט", "מרוץ ריצה"],
  },
  "family": {
    display: { en: "Kids", he: "לכל המשפחה" },
    emoji: "👨‍👩‍👧",
    keywords: [
      "עם ילדים",
      "פעוטות",
      "family",
      "במשפחות",
      "גיל הרך",
      "לכל המשפחה",
      "המשפחות",
      "למשפחות",
      "משפחות",
      "פעילויות לילדים",
      "פעילות לילדים",
    ],
  },
  "jazz": {
    display: { en: "jazz", he: "ג'אז" },
    emoji: "🎷",
    keywords: ["גאז", "jazz"],
  },
  "donation based": {
    display: { en: "donation based", he: "כובע" },
    emoji: "👒",
    keywords: ["כובע"],
  },
  "pub crawl": {
    display: { en: "pub crawl", he: "סבב ברים" },
    emoji: "🍻",
    keywords: ["bar crawl", "pub crawl", "סבב ברים"],
  },
  "bar": {
    display: { en: "bar", he: "בר" },
    emoji: "🍻",
    keywords: ["bar", "pub", "קוקטייל", "קוקטיילים", "cocktails", "בר"],
  },
  "high-tech-events": {
    display: { en: "high-tech events", he: "אירועי הייטק" },
    emoji: "💻",
    keywords: [
      "high tech",
      "technology",
      "innovation",
      "startups",
      "הייטק",
      "טכנולוגיה",
      "חדשנות",
      "סטארטאפים",
    ],
  },
  "jam": {
    display: { en: "jam", he: "ג'אם" },
    emoji: "🪕",
    keywords: ["jam", "jam session", "ג'אם"],
  },
  "gays": {
    display: { en: "LGBTQ+", he: 'להטב"ק' },
    emoji: "🏳️‍🌈",
    antiKeywords: ["בגאווה"],
    keywords: [
      "blackmilk",
      "chicas",
      "drag",
      "forever",
      "forevertlv",
      "gay",
      "gays",
      "gaze",
      "kok schok",
      "kokschok",
      "lgbt",
      "lgbtq",
      "men only",
      "ofra",
      "pag",
      "pushithard",
      "sauna",
      "straight friendly",
      "גאווה",
      "גברים בלבד",
      "גיי",
      "גייז",
      "דראג",
      "הומו",
      "לסביות",
      "מאש",
      "נשים בלבד",
      "עופרה בלי עופרה",
      "פאג",
      "פוראבר",
      "פוראח",
      "קוק שוק",
      "קוקשוק",
    ],
  },
  "women": {
    display: { en: "Women's events", he: "אירועים לנשים" },
    emoji: "👩",
    aiHint:
      "Events specifically for women, e.g. career meetups for women, networking events, women-only workshops, women's empowerment events, ladies nights.",
    keywords: [
      "women only",
      "ladies night",
      "נשים בלבד",
      "ערב נשים",
      "אירוע לנשים",
      "women",
      "נשים",
    ],
  },
  "expats": {
    display: { en: "Expats", he: "עולים חדשים" },
    emoji: "🌍",
    keywords: [
      "expat",
      "expats",
      "עולים חדשים",
      "עולה חדש",
      "עולה חדשה",
      "olim",
      "olim chadashim",
    ],
  },
  "hiphop": {
    display: { en: "hiphop", he: "היפ-הופ" },
    emoji: "🎧",
    keywords: [
      "hiphop",
      "hip hop",
      "היפהופ",
      "היפ הופ",
      "מוסיקה שחורה",
      "מוזיקה שחורה",
    ],
  },
  rnb: {
    display: { en: "R&B", he: "RnB" },
    emoji: "🎶",
    keywords: [
      "rnb",
      "r&b",
      "r n b",
      "אר אנ בי",
      "אר אן בי",
      "ארנבי",
    ],
  },
  "old-school": {
    display: { en: "old school", he: "אולד סקול" },
    emoji: "📼",
    keywords: [
      "old school",
      "oldskool",
      "אולד סקול",
      "אולדסקול",
    ],
  },
  "new-school": {
    display: { en: "new school", he: "ניו סקול" },
    emoji: "🧢",
    keywords: [
      "new school",
      "ניו סקול",
      "ניוסקול",
    ],
  },
  reggaeton: {
    display: { en: "reggaeton", he: "רגאטון" },
    emoji: "💃🏽",
    keywords: [
      "reggaeton",
      "רגאטון",
      "רגטון",
    ],
  },
  afrobeat: {
    display: { en: "afrobeat", he: "אפרוביט" },
    emoji: "🪘",
    keywords: [
      "afrobeat",
      "afro beat",
      "אפרוביט",
      "אפרוביטס",
    ],
  },
  latin: {
    display: { en: "latin", he: "לטיני" },
    emoji: "🌶️",
    keywords: [
      "latin",
      "latino",
      "latin music",
      "latin night",
      "latin dance",
      "לטיני",
      "לטינית",
      "לטיניים",
      "מוזיקה לטינית",
      "מוסיקה לטינית",
      "ריקוד לטיני",
      "ריקודים לטיניים",
    ],
  },
  "live music": {
    display: { en: "concerts and live music", he: "הופעות חיות" },
    aiHint:
      "e.g. הופעה, live bands, concerts, live performances, jam sessions. don't use for parties unless they are live music parties.",
    emoji: "🎸",
    antiKeywords: [
      "dj",
      "תקלוט",
      "דיגיי",
      "מסיבה",
      "standup",
      "סטנדאפ",
      "סטנדפ",
    ],
    keywords: [
      "blues",
      "show",
      "live band",
      "live performance",
      "cabaret",
      "jam",
      "jazz",
      "live music",
      "אלביס",
      "אנפלאגד",
      "אקוסטי",
      "באבי בר",
      "בארבי",
      "בהופעות",
      "בטברנה",
      "בלוז",
      "ג'אז",
      "גאם",
      "גיטרה",
      "הופעה חיה",
      "הופעה",
      "הופעות",
      "טברנה",
      "להקות",
      "להקתו",
      "מוזיקה חיה",
      "מוסיקה חיה",
      "מופע",
      "ערב שירה",
      "קאבר",
      "קברט",
      "קונטרבס",
    ],
  },
  "mainstream": {
    emoji: "💾",
    aiHint: "Including 90s.",
    display: { en: "mainstream", he: "מיינסטרים" },
    antiKeywords: ["בשביל מיינסטרים יש מקומות אחרים"],
    keywords: [
      "מיינסטרים",
      "mainstream",
      "90s",
      "ניינטיז",
      "pop",
      "דיסקו",
      "פופ",
      "דאנסהול",
      "britney",
      "בריטני",
    ],
  },
  "metal": {
    display: { en: "metal", he: "מטאל" },
    emoji: "🤘",
    keywords: ["metal", "מטאל"],
  },
  "nature-party": {
    display: { en: "nature party", he: "מסיבת טבע" },
    emoji: "👽🍄",
    keywords: [
      "outdoors rave",
      "nature party",
      "nature parties",
      "secret location",
      "בטבע",
      "בלב המדבר",
      "100% טבע",
      "מיקום סודי",
      "מסיבה בטבע",
      "מסיבות טבע",
      "מסיבת טבע",
      "מקום קסום",
      "סיקרט לוקיישן",
    ],
  },
  "out of town": {
    display: { en: "out of town", he: "מחוץ לעיר" },
    emoji: "🏕️",
    keywords: [
      "open air",
      "out of town",
      "אבן יהודה",
      "אורוות האומנים",
      "באוויר הפתוח",
      "כיפת השמיים",
      "מחוץ לעיר",
      "מחוץ לתל אביב",
      "פרדס חנה",
    ],
  },
  "movement": {
    display: { en: "Movement", he: "תנועה " },
    emoji: "🤸🏽",
    keywords: [
      "pilates",
      "yoga",
      "יוגה",
      "פילאטיס",
      "פילטיס",
      "פלדנקרייז",
    ],
  },
  "walking-tour": {
    emoji: "🚶",
    display: { en: "Walking Tour", he: "סיור" },
    keywords: ["walking tour", "סיור"],
  },
  "personal-development": {
    emoji: "🧘",
    aiHint:
      "Self improvement, tools for growth, self help, personal development, meditation, mindfulness.",
    display: { en: "Personal development", he: "התפתחות" },
    keywords: [
      "מסע התפתחות",
      "נטורופתית",
      "meditation",
      "מדיטציה",
      "מיינדפולנס",
      "סדנת טיהור",
    ],
  },
  "retreat": {
    display: { en: "retreat", he: "ריטריט" },
    emoji: "🏕️",
    keywords: [
      "retreat",
      "רטריט",
      "ריטריט",
    ],
  },
  swingers: {
    display: { en: "Swingers party", he: "מסיבת סווינגרס" },
    emoji: "👩🏼‍🤝‍👨🏽👫🏼",
    keywords: [
      "swinger club",
      "swingers",
      "חילופי זוגות",
      "מסיבת זוגות",
      "מסיבתסווינגרס",
      "סווינג",
      "סווינגרים",
      "סווינגרית",
      "סווינגרס",
      "סוינג",
      "סוינגרס",
    ],
  },
  fetish: {
    display: { en: "Fetish", he: "פטיש" },
    emoji: "👠",
    keywords: ["fetish", "פטיש", "kink", "קינק", "לבוש סקסי"],
  },
  cuddling: {
    display: { en: "Cuddling", he: "כרבולייה" },
    emoji: "🫂",
    keywords: [
      "cuddle",
      "cuddling",
      "כרבוליה",
      "כרבולייה",
      "כרבוליה",
      "כרבול",
      "כירבול",
    ],
  },
  "couple-meetup": {
    display: { en: "Couple Meetup", he: "מפגש זוגות" },
    emoji: "🫂",
    keywords: ["מפגש זוגות", "מפגשזוגות"],
  },
  "play-party": {
    display: { en: "Play Party", he: "פליי פארטי" },
    emoji: "🫦",
    keywords: [
      "liberal party",
      "play party",
      "sex party",
      "temple",
      "theclinic",
      "טמפל",
      "ליברל",
      "מסיבה ליברלית",
      "מסיבות סקס",
      "מסיבת סקס",
      "פלי פארטי",
      "פליי פארטי",
      "פלייפארטי",
    ],
  },
  munch: {
    display: { en: "Munch", he: "מאנץ'" },
    emoji: "⛓️💬",
    keywords: ["'מאנץ", "מאנץ'", "munch"],
  },
  "poly-meetup": {
    display: { en: "Poly Meetup", he: "מפגש פולי" },
    emoji: "👩🏼‍🤝‍👨🏽💬👫🏼",
    keywords: ["מפגש פולי", "poly meetup", "פוליאמורי", "פוליאמוריה", "פולי"],
  },
  bdsm: {
    display: { en: "BDSM", he: "בדסמ" },
    emoji: "⛓️",
    keywords: ["bdsm", "בדסמ", "femdom", "פמדום"],
  },
  shibari: {
    display: { en: "Shibari", he: "שיבארי" },
    emoji: "🪢",
    keywords: ["shibari", "שיבארי", "kinbaku", "קינבאקו", "rope bondage"],
  },
  orgy: {
    display: { en: "Orgy", he: "אורגיה" },
    emoji: "💦",
    keywords: [
      "אורגיה",
      "אורגיות",
      "orgy",
      "orgies",
      "group sex",
      "מין מרובה משתתפים",
      "מקדש סקס",
      "סקס מג'יק",
      "מין קבוצתי",
    ],
  },
  tantra: {
    display: { en: "Tantra", he: "טנטרה" },
    emoji: "🪷",
    keywords: ["טנטרה", "טאנטרה", "tantra"],
  },
  "standup": {
    display: { en: "standup comedy", he: "סטנדאפ" },
    emoji: "😂🎤",
    keywords: ["standup", "סטנדאפ", "סטאנדאפ", "קומיקאי", "comedian", "צחוקים"],
  },
  "talk": {
    display: { en: "talks", he: "הרצאות" },
    emoji: "💬",
    keywords: [
      "educational",
      "history",
      "lecture",
      "lectures",
      "talk",
      "היסטוריה",
      "הרצאה",
      "הרצאות",
      "שיח",
    ],
  },
  "grunge": {
    display: { en: "Grunge", he: "גרנג'" },
    emoji: "🎸",
    keywords: ["grunge", "גרנג'"],
  },
  "punk": {
    display: { en: "Punk", he: "פאנק" },
    emoji: "🤘",
    keywords: ["punk", "פאנק"],
  },
  "garage": {
    display: { en: "garage", he: "גראז'" },
    emoji: "🚗",
    keywords: ["garage", "גראז'", "bassline", "בייסליין"],
  },
  "drum-and-bass": {
    display: { en: "drum and bass", he: "דראם אנד בייס" },
    emoji: "🥁⚡🔊",
    keywords: [
      "dnb",
      "drum and base",
      "drum and bass",
      "דראם אנד בייס",
      "דראם",
      "בס",
    ],
  },
  house: {
    display: { en: "House", he: "האוס" },
    emoji: "🏠",
    keywords: [
      "house",
      "האוס",
      "האווס",
    ],
  },
  edm: {
    display: { en: "EDM", he: "מוסיקה אלקטרונית" },
    emoji: "🎛️",
    keywords: [
      "edm",
      "מוסיקה אלקטרונית",
      "electronic",
      "אלקטרוני",
      "אלקטרוניים",
      "אלקטרונית",
      "synth",
    ],
  },
  jungle: {
    display: { en: "Jungle music", he: "מוסיקה ג'אנגל" },
    emoji: "🌴",
    keywords: ["jungle", "ג'אנגל"],
  },
  hyperpop: {
    display: { en: "hyperpop", he: "הייפרפופ" },
    emoji: "💜",
    keywords: [
      "hyperpop",
      "hyper pop",
      "sOPHIE",
      "sophie",
      "arin hanson",
      "eggcene",
      "100 gecs",
      "charx",
      "dorian electra",
      "pup",
      "shrimp",
      "rela",
      "הייפרפופ",
      "ארין הנסון",
    ],
  },
  techno: {
    display: { en: "techno", he: "טכנו" },
    emoji: "🤖",
    keywords: [
      "techno",
      "אימגן",
      "טכנו",
    ],
  },
  "theater": {
    display: { en: "theater", he: "תיאטרון" },
    emoji: "🎭",
    keywords: ["הצגות", "הצגה", "theater", "תיאטרון", "תאטרון"],
  },
  poetry: {
    display: { en: "poetry", he: "הקראת שירה" },
    emoji: "📜",
    keywords: ["poetry", "הקראת שירה", "פואטרי סלאם", "מועדון כתב", "ספוקן"],
  },
  "circle-singing": {
    display: { en: "Circle singing", he: "מעגל שירה" },
    emoji: "☮️🧑‍🤝‍🧑",
    keywords: ["circle singing", "singing circle", "מעגל שירה", "מעגלי שירה"],
  },
  "trance": {
    display: { en: "trance music", he: "טראנס" },
    emoji: "👽",
    keywords: [
      "trance",
      "psytrance",
      "פסיי טראנס",
      "פסייטראנס",
      "טראנס",
      "טרנס",
    ],
    aiHint: "trance music, not to be confused with transexual",
  },
  "world music": {
    display: { en: "world music", he: "מוסיקת עולם" },
    emoji: "🌎",
    keywords: ["world music", "מוסיקת עולם"],
  },
  "longevity": {
    display: { en: "longevity", he: "לונגביטי" },
    emoji: "🌎",
    keywords: [
      "longevity",
      "רפואה",
      "הסתדרות הרופאים",
      "המכון לחדשנות",
      "רופאים",
      "לונגביטי",
    ],
  },
  "ma-kore-hayom": {
    display: { en: "Curated by Ma Kore Hayom", he: "מה-קורה-היום" },
    emoji: "✨",
    keywords: [],
  },
  "ayelet-megiddo": {
    display: {
      en: "Curated by Ayelet for Megiddo and the area",
      he: "איילת הבוטית",
    },
    emoji: "🦌",
    keywords: ["ayelet-curations"],
  },
  "enm-events-israel": {
    display: { en: "Curated by ENM Events Israel", he: "ENM Events Israel" },
    emoji: "💞",
    keywords: [],
  },
  sale: {
    display: { en: "fair", he: "יריד" },
    emoji: "🛒",
    keywords: ["fair", "פופ אפ", "פופ-אפ", "יריד", "pop up", "market", "שוק"],
  },
  festival: {
    display: { en: "Festival", he: "פסטיבל" },
    emoji: "🎪",
    aiHint:
      "Festivals of any kind (music, culture, multi-stage/area events). Often multi-day or with many acts.",
    keywords: [
      "festival",
      "פסטיבל",
    ],
  },
};

export const categoriesEnum = Object.keys(catsUntyped);

export const categoryRelations: Partial<Record<Category, Category[]>> = {
  "live music": ["karaoke", "jam", "singing circle"],
  dance: ["salsa", "bachata", "tango", "kizomba", "zouk"],
  edm: [
    "jungle",
    "house",
    "techno",
    "trance",
    "drum-and-bass",
    "garage",
  ],
  hiphop: ["old-school", "new-school", "rnb"],
  sports: ["movement", "swimming", "volleyball"],
  bdsm: ["shibari"],
  sexuality: [
    "bdsm",
    "couple-meetup",
    "cuddling",
    "fetish",
    "munch",
    "orgy",
    "play-party",
    "poly-meetup",
    "shibari",
    "swingers",
    "tantra",
  ],
  party: [
    "80s",
    "burn",
    "fetish",
    "hiphop",
    "rnb",
    "old-school",
    "new-school",
    "reggaeton",
    "afrobeat",
    "latin",
    "mainstream",
    "nature-party",
    "play-party",
    "techno",
    "trance",
  ],
};

export const enrichSuperCategories = pipe(
  pairRight(
    (categories: Category[]) =>
      pipe(
        valFilterSync<Category, Category[]>((cs) =>
          categories.some((c) => cs.includes(c))
        ),
        objectKeys<Category>,
      )(categoryRelations),
  ),
  concat<Category>,
  unique<Category>,
  sort<Category>,
);

export type Category = keyof typeof catsUntyped;

export const cats: Record<Category, CategorySpec> = catsUntyped;

export const isCategoryKeyword = letIn(
  pipe(
    Object.values<CategorySpec>,
    mapCat(({ keywords }: CategorySpec) => keywords),
  )(cats),
  (kws) => (y: string) => kws.includes(y),
);

export const categoryEmoji = (category: Category) =>
  category in cats ? cats[category].emoji : null;

export const renderHintForAI = (category: Category) => {
  const x = cats[category];
  if (!x) return category;
  if ("aiHint" in x) return `${x.display.en} (${x.aiHint})`;
  return x.display.en;
};
